export enum EstadoCivil {
  SOLTEIRO = "SOLTEIRO",
  CASADO = "CASADO",
  SEPARADO = "SEPARADO",
  DIVORCIADO = "DIVORCIADO",
  VIUVO = "VIUVO",
  UNIAO_ESTAVEL = "UNIAO_ESTAVEL",
}
